import React from 'react';
import './experience.css';
import {BsPatchCheckFill} from 'react-icons/bs'

function Experience() {
  return (
    <section id='experience'>
<h5>What Skills I have</h5>
<h2>My Experience</h2>



<div className="container experience__container">

  <div className="experience_frotend">
<h3>Frontend Experience</h3>
<div className="experience__content">

<article className='experience__details'>


<BsPatchCheckFill className='experience__details-icon'/>
<div><h4>HTML</h4>
<small className='text-light'>Experienced</small></div>
</article>
<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
<h4>CSS</h4>
<small className='text-light'>Intermediate</small>
</div>
</article>

<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
<h4>Bootstrap</h4>
<small className='text-light'>Experienced</small>
</div>
</article>

<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
<h4>JavaScript</h4>
<small className='text-light'>Intermediate</small>
</div>
</article>

<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
  <h4>ReactJS</h4>
<small className='text-light'>Intermediate</small>
</div>
</article>


</div>


  </div>
{/*End of front End*/ }

  <div className="experience_backend">
    <h3>Backend Experience</h3>
<div className="experience__content">

<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
<h4>MongoDB</h4>
<small className='text-light'>Yet to Learn</small>
</div>
</article>

<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
<h4>Express JS</h4>
<small className='text-light'>Yet to Learn</small>
</div>
</article>

<article className='experience__details'>
<BsPatchCheckFill className='experience__details-icon'/>
<div>
<h4>Node JS</h4>
<small className='text-light'>Yet to Learn</small>
</div>
</article>
</div>

  </div>
</div>

    </section>
  )
}

export default Experience